import { content } from '../../data/footer_content'

import sbcLoro from '../../img/sbcEgr.svg'
import metaLogo from '../../img/Meta.svg'
import gambLogo from '../../img/gamb.svg'
import Logo from '../../img/Logo.svg'
import Union_L_B from '../../img/Union_L_B.svg'
import Union_R_B from '../../img/Union_R_B.svg'

import './Footer.scss'


export default function Footer() {

    return(

        <>
            <div className="footer">

                <img src={Union_L_B} alt="" className='bottom-menu__decor-left'/>
                <img src={Union_R_B} alt="" className='bottom-menu__decor-right' />

                <div className="container footer__container">

                    <div className="footer__container-left">
                        <img src={Logo} alt="logo" width='127' className='footer__container-left--logo'/>
                        <img src={sbcLoro} alt="sbcLoro" width='279' className='footer__container-left--sbcLoro'/>
                        <img src={metaLogo} alt="metaLogo" width='282' className='footer__container-left--metaLogo'/>
                    </div>
                    <div className="footer__container-mid">
                        <p className="text text__copyright">{content.copyright}</p>
                        <p className="text text__disclaimer">{content.disclaimer}</p>
                    </div>
                    <div className="footer__container-right">
                        <img src={gambLogo} alt="gambLogo" width='160' className='footer__container-right--gambLogo'/>
                        <a className="text text__mail" href={`mailto:${content.mail}`}>{content.mail}</a>
                    </div>

                </div>

            </div>
            <div className="sub-footer">
                <div className="sub-container">
                    <p className='text' >{content.rights}</p>
                    {/* <a href="/privacy-policy" className='text text__policy' >{content.policy}</a> */}
                </div>
            </div>
        </>

    )



}